import { render, staticRenderFns } from "./mbs.vue?vue&type=template&id=7365e258&"
import script from "./mbs.vue?vue&type=script&lang=js&"
export * from "./mbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports